import React from "react";
import HubspotForm from "react-hubspot-form";
import Polygon from "./polygon.svg";
import "./styles.scss";

function FooterEmailSignUpForm() {
	return (
		<div className="email-sign-up-footer">
			<div className="section section--is-green section--is-paddingless">
				<div className="container">
					<div className="email-sign-up-footer__container">
						<div className="email-sign-up-footer__description">
							<h2 className="email-sign-up-footer__heading">
                <div className="email-sign-up-footer__heading-text">Trust us, you're gonna want this in your inbox.</div>
								<div className="email-sign-up-footer__polygon">
									<img src={Polygon} alt="" aria-hidden="true" />
								</div>
							</h2>
							<p className="text text--xsmall">Join the Irish Titan sphere of influence. We'll send a couple emails a month. No trash, no spam, just the shenanigans we get up to.</p>
						</div>
						<div className="email-sign-up-footer__form">
              <div className="text text--xxsmall text--weight-semi-bold text--green-text">Go ahead, fill it out.</div>
              <div className="text text--large text--weight-bold text--black">We dare ya’.</div>
							<HubspotForm
								portalId="544161"
								formId="cde02766-3187-4ab7-bd8c-f8bb2705a7b9"
								region="na1"
								css=""
                cssClass="email-sign-up-footer"
								submitButtonClass="btn btn--sm btn--black-green"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default FooterEmailSignUpForm;